import { useState } from 'react';
import { Organization } from '../../api';
import { getErrorMessage } from '../../../../shared/src';

interface DeleteOrgModalProps {
  org: Organization;
  onClose: () => void;
  onDelete: () => Promise<void>;
}

export function DeleteOrgModal({ org, onClose, onDelete }: DeleteOrgModalProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [confirmText, setConfirmText] = useState('');

  const expectedConfirmText = org.slug;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (confirmText !== expectedConfirmText) {
      setError(`Please type "${expectedConfirmText}" to confirm deletion`);
      return;
    }

    setError('');
    setLoading(true);

    try {
      await onDelete();
    } catch (err: unknown) {
      setError(getErrorMessage(err));
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-danger" onClick={(e) => e.stopPropagation()}>
        <h2>Delete Organization</h2>
        <p className="warning-text">
          This action is <strong>irreversible</strong>. The organization "{org.name}"
          and all its data including the S3 bucket will be permanently deleted.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Type <code>{expectedConfirmText}</code> to confirm:</label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder={expectedConfirmText}
              autoFocus
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
            <button
              type="submit"
              className="btn-danger"
              disabled={loading || confirmText !== expectedConfirmText}
            >
              {loading ? 'Deleting...' : 'Delete Permanently'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
